var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "18px",
    viewBox: "0 0 30 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Owner",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Owner---folders-shared-with-me",
    transform: "translate(-790.000000, -260.000000)",
    fill: "#E2E8F6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(790.000000, 258.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7872694,8.33166081 C29.5023974,7.98257634 23.1252909,0 15.0120228,0 C6.89875463,0 0.521858137,7.98279895 0.236777739,8.33166081 C-0.078925913,8.71302375 -0.078925913,9.25339392 0.236777739,9.66706713 C0.521649773,10.0173919 6.89875463,18 15.0120228,18 C23.1252909,18 29.502189,9.98635365 29.7872694,9.66833919 C30.0709102,9.28573599 30.0709102,8.71429581 29.7872694,8.33169261 L29.7872694,8.33166081 Z M15.0120228,14.978799 C11.7293362,14.978799 9.07647842,12.3079864 9.07647842,8.99980919 C9.07647842,5.69309485 11.727884,3.02081935 15.0120228,3.02081935 C18.2947094,3.02081935 20.9475671,5.69287224 20.9475671,8.99980919 C20.9475671,12.3067461 18.2949304,14.978799 15.0120228,14.978799 Z",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9230769,9.23076923 C18.9230769,11.2706089 17.2704469,12.9230769 15.2307692,12.9230769 C13.1910916,12.9230769 11.5384615,11.2704469 11.5384615,9.23076923 C11.5384615,7.19109155 13.1910916,5.53846154 15.2307692,5.53846154 C17.2704469,5.53846154 18.9230769,7.19109155 18.9230769,9.23076923",
    id: "Fill-2"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view_icon.161ef861248085079bc8fc06783fd3cc.svg";
export { ForwardRef as ReactComponent };